import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../app/store';
import { DashboardExtraReducer } from './dashboardThunk';


export interface State {
  isLoading: boolean,
  kpis: any[],
  myKpis: any[],
  layout?: any,
}

const initialState: State = {
  isLoading: false,
  kpis: [],
  myKpis: [],
  layout: {},
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
  },

  extraReducers: (builder) => {
    DashboardExtraReducer(builder);
  }
});

// export const {  } = dashboardSlice.actions;

export default dashboardSlice.reducer;
